import axios from 'axios';
import { DoorConfiguration } from '../../configurator/DoorConfiguration';
import store from '../../store/index';
import statusTypes from '../../configurator/StatusTypes';

//PC means product configurator
const createPCBaseURL = `api/productconfiguration/save`;
const updatePCBaseURL = `api/productconfiguration/update`;

export default {
    saveCurrentProductConfigurator(data : any)  
    {
        
        var productId = store.state.configuratorModule.productId;
        var chargeId = store.state.configuratorModule.chargeId;
        var articleNumber = store.getters['configuratorModule/getCurrentDoorConfiguration'].GetCurrentDoorArticleNumber();
        var mountingMaterialItems = store.getters['mountingMaterialModule/getMountingMaterialItemsForSap'];

        var modelSelectionData = data.Get(DoorConfiguration.ModelSelection);
        var functionsData = data.Get(DoorConfiguration.Functions);
        var frameData = data.Get(DoorConfiguration.Frame);
        var meassureData = data.Get(DoorConfiguration.Measure);
        var doorSurfaceData = data.Get(DoorConfiguration.DoorLeafSurface);
        var exteriorAccessoryData = data.Get(DoorConfiguration.ExteriorAccessory);
        var mountinMaterialData = data.Get(DoorConfiguration.MountingMaterial);
        var blindStockMultiplexData = data.Get(DoorConfiguration.BlindstockMultiplex);
        var furtherInformationData = data.Get(DoorConfiguration.FurtherInformation);

        var arr = new Array();
        var mountingMaterials = new Array();
        var myAccessories = new Array();

        modelSelectionData.forEach((element: any) => {       
            if(element.code === "KTU_MM_ARTIKELNR")
            {
                var obj = {
                    "Name" : element.code,
                    "Value" : articleNumber,
                    "ValueId" : element.value.id
                };
                arr.push(obj);
            }else {
                if(typeof element.value !== 'undefined') {
                    var obj = {
                        "Name" : element.code,
                        "Value" : element.value.value,
                        "ValueId" : element.value.id
                    };

                    arr.push(obj);
                }else {
                    alert(element.code);
                }
            }           
            
        });

        functionsData.forEach((element: any) => {
            if(typeof element.value !== 'undefined') {
                var obj = {
                    "Name" : element.code,
                    "Value" : element.value.value,
                    "ValueId" : element.value.id
                };

                arr.push(obj);
            }else {
                alert(element.code);
            }
        });
        frameData.forEach((element: any) => {
            if(typeof element.value !== 'undefined') {
                var obj = {
                    "Name" : element.code,
                    "Value" : element.value.value,
                    "ValueId" : element.value.id
                };

                arr.push(obj);
            }else {
                alert(element.code);
            }
        });
        meassureData.forEach((element: any) => {
            if(typeof element.value !== 'undefined') {
                var obj = {
                    "Name" : element.code,
                    "Value" : element.value.value,
                    "ValueId" : element.value.id
                };

                arr.push(obj);
            }else {
                alert(element.code);
            }
        });
        doorSurfaceData.forEach((element: any) => {          
            if(element.code !== "KTU_MM_TUEROBERFL_F_GBS" 
            && element.code !== "KTU_MM_TUEROBERFL_L_GBS" 
            && element.code !== "KTU_MM_TUEROBERFL_GBS"
            && element.code !== "KTU_MM_TUEROBERFL_F_BS"
            && element.code !== "KTU_MM_TUEROBERFL_L_BS"
            && element.code !== "KTU_MM_TUEROBERFL_BS")
            {
                if(typeof element.value !== 'undefined') {
                    var obj = {
                        "Name" : element.code,
                        "Value" : element.value.value,
                        "ValueId" : element.value.id
                    };

                    arr.push(obj);
                }else {
                    alert(element.code);
                }
            }          
        });

        if(doorSurfaceData.length > 0)
        {
            var characterisiticsDoor = getDoorSurfaceCharacteristics(doorSurfaceData);
            characterisiticsDoor.forEach((element : any) => {
                arr.push(element);
            });
        }        
        exteriorAccessoryData.forEach((element: any) => {
            if(typeof element.value !== 'undefined') {
                var obj = {
                    "Name" : element.code,
                    "Value" : element.value.value,
                    "ValueId" : element.value.id
                };

                arr.push(obj);
            }else {
                alert(element.code);
            }

        });
        mountinMaterialData.forEach((element: any) => {
            if(typeof element.value !== 'undefined') {
                var obj = {
                    "Name" : element.code,
                    "Value" : element.value.value,
                    "ValueId" : element.value.id
                };

                arr.push(obj);
            }else {
                alert(element.code);
            }
        });

        mountingMaterialItems.forEach((element:any, index: number) => {
            var ktuMat = {
                "Name": "KTU_MAT"+(index+1),
                "Value": new Array(),
            };
            element.forEach((data: any) => {
                var obj = {
                    "mname" : data.code,
                    "mvalue": data.value
                };
                ktuMat.Value.push(obj);
            });
            mountingMaterials.push(ktuMat);
        });

        blindStockMultiplexData.forEach((element: any) => {
            if(typeof element.value !== 'undefined') {
                var obj = {
                    "Name" : element.code,
                    "Value" : element.value.value,
                    "ValueId" : element.value.id
                };

                arr.push(obj);
            }else {
                alert(element.code);
            }
        });
        furtherInformationData.forEach((element: any) => {

            if(typeof element.value !== 'undefined') {
                var obj = {
                    "Name" : element.code,
                    "Value" : element.value.value,
                    "ValueId" : element.value.id
                };

                arr.push(obj);
            }else {
                alert(element.code);
            }
                              
        });

        var textLineL = store.state.furtherInformationModule.TEXT_LINE_L;
        var textLineLD = store.state.furtherInformationModule.TEXT_LINE_LD;
        var textLineA = store.state.furtherInformationModule.TEXT_LINE_A;
        var textLineK = store.state.furtherInformationModule.TEXT_LINE_K;

        var PurchNo = store.state.furtherInformationModule.PURCH_NO_C;
        var Incoterm = store.state.furtherInformationModule.incoterm;        
        var PaymentTerm = store.state.furtherInformationModule.paymentTerm;
        var DeliveryAddress = store.state.furtherInformationModule.deliveryAddress;
        var Land = store.state.furtherInformationModule.land;
        var Zone = store.state.furtherInformationModule.zone;
        var Freight = store.state.furtherInformationModule.freight;

        var objTextLine_L = {
            "Name" : "TEXT_LINE_L",
            "Value" : textLineL,
            "ValueId" : 0
        }

        var objTextLine_LD = {
            "Name" : "TEXT_LINE_LD",
            "Value" : textLineLD,
            "ValueId" : 0
        }

        var objTextLine_A = {
            "Name" : "TEXT_LINE_A",
            "Value" : textLineA,
            "ValueId" : 0
        }

        var objTextLine_K = {
            "Name" : "TEXT_LINE_K",
            "Value" : textLineK,
            "ValueId" : 0
        }

        var objPurchNo = {
            "Name": "PURCH_NO_C",
            "Value": PurchNo,
            "ValueId": 0
        }

        var objIncoterm = {
            "Name" : "Incoterm",
            "Value" : Incoterm,
            "ValueId" : 0
        }

        var objPaymentTerm= {
            "Name" : "PaymentTerm",
            "Value" : PaymentTerm,
            "ValueId" : 0
        }
        var objDeliveryAddres = {
            "Name" : "DeliveryAddress",
            "Value" : DeliveryAddress,
            "ValueId" : 0
        }

        var objLand = {
            "Name" : "KTU_MM_FRACHT_LAND",
            "Value" : Land,
            "ValueId" : 0
        }

        var objZone = {
            "Name" : "KTU_MM_FRACHT_ZONE",
            "Value" : Zone,
            "ValueId" : 0
        }

        var objFreight = {
            "Name" : "KTU_MM_FRACHT_GEWICHT",
            "Value" : Freight,
            "ValueId" : 0
        }

        arr.push(objTextLine_L);
        arr.push(objTextLine_LD);
        arr.push(objTextLine_A);
        arr.push(objTextLine_K);
        if(DeliveryAddress !== '')
        {
            arr.push(objDeliveryAddres);
        }
        arr.push(objPurchNo);
        arr.push(objIncoterm);
        arr.push(objPaymentTerm);
        arr.push(objLand);
        arr.push(objZone);
        arr.push(objFreight);

        arr.filter(x => x.Name === "")

        const customer = store.getters['furtherInformationModule/getCustomer']

         var createProductConfigurator = {
            CreatedBy : store.state.user.userId,
            CompanyId : store.state.user.companyId,
            ProductConfigurationKeyValueItems : arr,
            MountingMaterialItems : mountingMaterials,
            ApplicationState : store.state,
            Status : statusTypes.InProgress,
            ChargeId : chargeId,
             MyAccessories: [...store.state.furtherInformationModule.accessories],
             Customer: customer
         };

         var changedPrice = store.state.currentProduct.changedPrice
         if( changedPrice == null)
         {
            changedPrice = 0;
         }
         var updateProductConfigurator = {
             Id : productId,
             ProductConfigurationKeyValueItems : arr,
             MountingMaterialItems : mountingMaterials,
             ApplicationState : store.state,
             Status : statusTypes.InProgress,
             ChangedPrice : changedPrice,
             ChargeId : chargeId,
             MyAccessories: [...store.state.furtherInformationModule.accessories],
             Customer: customer
         }

        const token = localStorage.getItem('token')
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        store.state.currentProduct.applicationState = {};
        if(productId == 0)
        {
            return axios.post(createPCBaseURL, createProductConfigurator);
        }else {
            return axios.post(updatePCBaseURL, updateProductConfigurator);
        }
    }
}


function getDoorSurfaceCharacteristics(doorSurfaceData : any[]) {

    var arr = new Array();

    //DoorSurfaceCharacteristic
    var KTU_MM_TOBERFL_BS = doorSurfaceData.filter((x: any) => x.code === "KTU_MM_TOBERFL_BS")[0];
    var KTU_MM_TOBERFL_GBS = doorSurfaceData.filter((x: any) => x.code === "KTU_MM_TOBERFL_GBS")[0];

    if(KTU_MM_TOBERFL_BS.value.value === "DEKOR")
    {
       var obj = {
           "Name" : "KTU_MM_TUEROBERFL_BS",
           "Value" : doorSurfaceData.filter((x: any) => x.code == "KTU_MM_TUEROBERFL_BS")[0].value.value,
           "ValueId" : doorSurfaceData.filter((x: any) => x.code == "KTU_MM_TUEROBERFL_BS")[0].value.id
       };

       var obj1 = {
           "Name" : "KTU_MM_TUEROBERFL_F_BS",
           "Value" : "",
           "ValueId" : 0
       };

       var obj2 = {
           "Name" : "KTU_MM_TUEROBERFL_L_BS",
           "Value" : "",
           "ValueId" : 0
       };

       arr.push(obj);
       arr.push(obj1);
       arr.push(obj2);
       
    }else if(KTU_MM_TOBERFL_BS.value.value === "FURNIER")
    {

       var obj3 = {
           "Name" : "KTU_MM_TUEROBERFL_F_BS",
           "Value" : doorSurfaceData.filter((x: any) => x.code == "KTU_MM_TUEROBERFL_F_BS")[0].value.value,
           "ValueId" : doorSurfaceData.filter((x: any) => x.code == "KTU_MM_TUEROBERFL_F_BS")[0].value.id
       };

       var obj4 = {
           "Name" : "KTU_MM_TUEROBERFL_BS",
           "Value" : "",
           "ValueId" : 0
       };

       var obj5 = {
           "Name" : "KTU_MM_TUEROBERFL_L_BS",
           "Value" : "",
           "ValueId" : 0
       };
       arr.push(obj3);
       arr.push(obj4);
       arr.push(obj5);

    }else {
       var obj6 = {
           "Name" : "KTU_MM_TUEROBERFL_L_BS",
           "Value" : doorSurfaceData.filter((x: any) => x.code == "KTU_MM_TUEROBERFL_L_BS")[0].value.value,
           "ValueId" : doorSurfaceData.filter((x: any) => x.code == "KTU_MM_TUEROBERFL_L_BS")[0].value.id
       };

       var obj7 = {
           "Name" : "KTU_MM_TUEROBERFL_BS",
           "Value" : doorSurfaceData.filter((x: any) => x.code == "KTU_MM_TUEROBERFL_BS")[0].value.value,
           "ValueId" : doorSurfaceData.filter((x: any) => x.code == "KTU_MM_TUEROBERFL_BS")[0].value.id
       };

       var obj8 = {
           "Name" : "KTU_MM_TUEROBERFL_F_BS",
           "Value" : "",
           "ValueId" : 0
       };
       arr.push(obj6);
       arr.push(obj7);
       arr.push(obj8);
    }


    if(KTU_MM_TOBERFL_GBS.value.value === "DEKOR")
    {
       var obj9 = {
           "Name" : "KTU_MM_TUEROBERFL_GBS",
           "Value" : doorSurfaceData.filter((x: any) => x.code == "KTU_MM_TUEROBERFL_GBS")[0].value.value,
           "ValueId" : doorSurfaceData.filter((x: any) => x.code == "KTU_MM_TUEROBERFL_GBS")[0].value.id
       };

       var obj10 = {
           "Name" : "KTU_MM_TUEROBERFL_F_GBS",
           "Value" : "",
           "ValueId" : 0
       };

       var obj11 = {
           "Name" : "KTU_MM_TUEROBERFL_L_GBS",
           "Value" : "",
           "ValueId" : 0
       };

       arr.push(obj9);
       arr.push(obj10);
       arr.push(obj11);
       
    }else if(KTU_MM_TOBERFL_GBS.value.value === "FURNIER")
    {

       var obj12 = {
           "Name" : "KTU_MM_TUEROBERFL_F_GBS",
           "Value" : doorSurfaceData.filter((x: any) => x.code == "KTU_MM_TUEROBERFL_F_GBS")[0].value.value,
           "ValueId" : doorSurfaceData.filter((x: any) => x.code == "KTU_MM_TUEROBERFL_F_GBS")[0].value.id
       };

       var obj13 = {
           "Name" : "KTU_MM_TUEROBERFL_GBS",
           "Value" : "",
           "ValueId" : 0
       };

       var obj14 = {
           "Name" : "KTU_MM_TUEROBERFL_L_GBS",
           "Value" : "",
           "ValueId" : 0
       };
       arr.push(obj12);
       arr.push(obj13);
       arr.push(obj14);

    }else {
       var obj15 = {
           "Name" : "KTU_MM_TUEROBERFL_L_GBS",
           "Value" : doorSurfaceData.filter((x: any) => x.code == "KTU_MM_TUEROBERFL_L_GBS")[0].value.value,
           "ValueId" : doorSurfaceData.filter((x: any) => x.code == "KTU_MM_TUEROBERFL_L_GBS")[0].value.id
       };

       var obj16 = {
           "Name" : "KTU_MM_TUEROBERFL_GBS",
           "Value" : doorSurfaceData.filter((x: any) => x.code == "KTU_MM_TUEROBERFL_GBS")[0].value.value,
           "ValueId" : doorSurfaceData.filter((x: any) => x.code == "KTU_MM_TUEROBERFL_GBS")[0].value.id
       };

       var obj17 = {
           "Name" : "KTU_MM_TUEROBERFL_F_GBS",
           "Value" : "",
           "ValueId" : 0
       };
       arr.push(obj15);
       arr.push(obj16);
       arr.push(obj17);
    }

    return arr;
}